// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

/**
 * Maps provider rejection reason codes to human-readable labels.
 * Codes match the backend ProviderRejectionRequest allowableValues.
 */
export const REJECTION_REASON_LABELS: Record<string, string> = {
  NO_POLICY_FOR_CLIENT: 'No policy for this client',
  ADDRESS_MISMATCH: 'Address does not match',
  EMAIL_MISMATCH: 'Email does not match',
  MISSING_SIGNATORY: 'Missing an additional signatory',
  NO_AUTHORITY: 'Signatory does not have authority on this policy',
  LOA_EXPIRED: 'LOA has expired',
  OTHER: 'Other',
};

export function getRejectionReasonLabel(code?: string): string {
  if (!code) return '';
  return REJECTION_REASON_LABELS[code] || code;
}
